import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const submitApplication = (data) => api.post("/applications", data);
export const submitPartnership = (data) => api.post("/partnerships", data);
export const submitContact = (data) => api.post("/contacts", data);
export const submitSpeakingInquiry = (data) => api.post("/speaking", data);
export const subscribeNewsletter = (email) =>
    api.post("/newsletter", { email });
export const getStats = () => api.get("/stats");

export const uploadResume = (file) => {
    const form = new FormData();
    form.append("file", file);
    return api.post("/upload/resume", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};
